import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import {
  updatePodcastDataAfterFetch
} from '../../../../redux/actions/app-actions';
import axios from 'axios';
import { default as config, CONSTANTS } from '../../../../constants/constants';
import { firebase } from '../../../../firebase';
import swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import BlockUi from 'react-block-ui';
import { fetchSubscribedPodcasts } from '../../../../apis/podcasts';

const validUrl = (value) =>
  value &&
  !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i.test(
    value
  )
    ? 'Please type a valid url'
    : undefined;

const required = (value) => (value ? undefined : 'Required');

const renderField = ({
  input,
  label,
  type,
  placeholder,
  meta: { touched, error }
}) => (
  <div>
    <label>{label}</label>
    <div style={{ marginBottom: '15px' }}>
      <input
        {...input}
        type={type}
        placeholder={placeholder}
        className="styleField"
        style={{ width: '100%' }}
      />
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);

let PodcastForm = (props) => {
  const { handleSubmit, submitting, pristine, reset } = props;

  return (
    <form onSubmit={handleSubmit} style={{ marginLeft: '10px' }}>
      <div>
        <Field
          name="name"
          component={renderField}
          type="text"
          label="(*)Name"
          placeholder="Name"
          validate={[required]}
        />
        <Field
          name="feedUrl"
          component={renderField}
          type="text"
          label="(*)Feed Url"
          placeholder="Feed Url"
          validate={[required, validUrl]}
        />
      </div>
      <div style={{ marginTop: '15px' }}>
        <button
          type="submit"
          className="btn btn-success"
          disabled={pristine || submitting}
          style={{ marginRight: '10px' }}
        >
          Submit
        </button>
        <button
          type="button"
          className="btn"
          disabled={pristine || submitting}
          onClick={reset}
        >
          Clear
        </button>
      </div>
    </form>
  );
};

class ModalPodcastEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blocking: false
    };
  }

  handleSubmit = (values) => {
    values.webPodcast = true;
    values.subscribed = true;
    if (this.props.podcastId === null) {
      values.podcastId = 0;
    } else {
      values.podcastId = this.props.podcastId;
    }

    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        const options = {
          method: 'POST',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/podcasts`,
          data: values
        };
        this.setState({ blocking: true });
        var $this = this;
        axios(options).then(function(response) {
          if (response.data.id !== null) {
            $this.setState({ blocking: false });
            fetchSubscribedPodcasts(token).then((res) =>
              $this.props.dispatch(updatePodcastDataAfterFetch(res))
            );
            $this.props.onHide();
          } else {
            $this.setState({ blocking: false });
            swal({
              imageUrl: CONSTANTS.swalLogo,
              title: '<div class="titleModal">We\'re sorry but feed URL is invalid.</div>',
              html:
                '<p class="contentModal">Please enter a valid feed url.</p>',
              showConfirmButton: false,
              showCloseButton: true,
              background: '#121C24',
              allowOutsideClick: false
            });
          }
        });
      });
    }
  };

  render() {
    return (
      <div>
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">
              {this.props.podcastId === null
                ? 'Add a new podcast'
                : 'Edit this podcast'}
            </Modal.Title>
          </Modal.Header>
          <BlockUi tag="div" blocking={this.state.blocking}>
            <Modal.Body>
              <PodcastForm
                onSubmit={this.handleSubmit}
                initialValues={{
                  name: this.props.name,
                  feedUrl: this.props.feedUrl,
                  imageUrl:
                    this.props.imageUrl !== null &&
                    this.props.imageUrl.startsWith('data')
                      ? null
                      : this.props.imageUrl,
                  artistName: this.props.artistName
                }}
              />
            </Modal.Body>
          </BlockUi>
        </Modal>
      </div>
    );
  }
}

PodcastForm = reduxForm({
  form: 'podcastForm'
  //validate
})(PodcastForm);

const mapStateToProps = (store) => {
  return {
    podcasts: store.app.podcasts
  };
};

export default connect(mapStateToProps)(ModalPodcastEdit);
